import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=71263216&scoped=true&"
import script from "./DataGrid.vue?vue&type=script&lang=ts&"
export * from "./DataGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71263216",
  null
  
)

export default component.exports